(function (Cobalt) {
    var Analytics = /** @class */ (function () {
        function Analytics() {
        }
        Analytics.initialize = function () {
            if (Analytics.trackingId.length < 1 || this.initialized) {
                // don't initialize if there is not tracking id or if we're already initialized
                return;
            }
            // download analytics library
            this.initializeAnalytics();
            // create the tracker object
            ga('create', this.trackingId, 'auto', { 'name': Analytics.trackerName });
            // hook up to click handler for anything with the proper data attribute defined
            this.handleClicks();
            this.initialized = true;
        };
        Analytics.sendEvent = function (eventCategory, eventAction, eventLabel, eventValue) {
            // use a param object so we don't accidentally get these out of order
            var params = {
                'hitType': 'event',
                'eventCategory': eventCategory,
                'eventAction': eventAction,
                'eventLabel': eventLabel,
                'eventValue': eventValue // optional but must be a non-negative number
            };
            ga(Analytics.sendCommand, params);
        };
        Analytics.initializeAnalytics = function () {
            // nasty nasty boilerplate initialization code
            // from https://developers.google.com/analytics/devguides/collection/analyticsjs/
            (function (i, s, o, g, r) {
                i['GoogleAnalyticsObject'] = r;
                i[r] = i[r] || function () {
                    (i[r].q = i[r].q || []).push(arguments);
                }, i[r].l = +new Date();
                var a = s.createElement(o), m = s.getElementsByTagName(o)[0];
                a.async = 1;
                a.src = g;
                m.parentNode.insertBefore(a, m);
            })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
        };
        Analytics.handleClicks = function () {
            ///<summary>Convenience method for auto-hooking into elements' click event and sending analytics data</summary>
            // Event tracking: https://developers.google.com/analytics/devguides/collection/analyticsjs/events
            // data-ga-click-event-tracking-category is required, so our selector is based on that. the rest are optional
            $(document).on('click', '[data-ga-click-event-tracking-category]', function () {
                // bail if the category is blank since it's required
                var category = $(this).data('ga-click-event-tracking-category');
                if (!category || category.trim().length == 0) {
                    return;
                }
                // make sure the eventValue is either undefined or a non-negative number
                var value = +$(this).data('ga-click-event-tracking-value');
                var eventValue;
                if (!isNaN(value) && value > -1) {
                    eventValue = value;
                }
                // send to ga
                Cobalt.Analytics.sendEvent($(this).data('ga-click-event-tracking-category'), 'click', $(this).data('ga-click-event-tracking-label'), eventValue);
            });
        };
        ///<summary>Class that initializes Google Analytics and will auto-hook into the click
        /// event of elements containing the proper data attributes.</summary>
        Analytics.trackerName = 'downloadTracker';
        Analytics.sendCommand = Analytics.trackerName + '.send'; // downloadTracker.send
        Analytics.initialized = false;
        return Analytics;
    }());
    Cobalt.Analytics = Analytics;
})(Cobalt || (window.Cobalt = {}));


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Analytics.js